import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from 'src/app/shared/shared.module';
import { ShiftsRoutingModule } from './shifts-routing.module';

import { ShiftsComponent } from './shifts.component';
import { ShiftDetailsComponent } from './components/shift-details/shift-details.component';
import { ShiftViewComponent } from './components/shift-view/shift-view.component';


@NgModule({
  declarations: [ShiftsComponent, ShiftDetailsComponent, ShiftViewComponent],
  imports: [
    CommonModule,
    SharedModule,
    ShiftsRoutingModule
  ]
})
export class ShiftsModule { }
